import React, {Component} from 'react';
import Modal from 'react-bootstrap-modal';
import {t} from 'l10n';

import {Form, ErrorContainer} from 'form';

import '../../sass/modals/modalChangePassword.scss';

import {changePassword} from 'backend-helpers/member';

class ModalChangePassword extends Component {
    constructor(props) {
        super(props);
        this.state = {};

        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(formData, setErrors) {
        let {closeFn} = this.props;

        changePassword(formData).then(function() {
            closeFn();
        }).catch(function(error) {
            setErrors(error.message);
        });
    }

    render() {
        const {show, closeFn} = this.props;

        return (
            <div>
                <Modal className="change-password" show={show} onHide={closeFn}>
                    <Modal.Body>
                        <div className="close" onClick={closeFn}></div>
                        <p className="modal-title">{t('Change password')}</p>
                        <div className="form">
                            <Form onSubmit={this.onSubmit}>
                                <ErrorContainer data-errorcontainer={true} />
                                <div className="form-group">
                                    <label>{t('Old password:')}</label>
                                    <input type="password" name="password_old" />
                                </div>
                                <div className="form-group">
                                    <label>{t('New password:')}</label>
                                    <input type="password" name="password"/>
                                </div>
                                <div className="form-group">
                                    <label>{t('Confirm new password:')}</label>
                                    <input type="password" name="password2"/>
                                </div>
                                <div className="form-group-buttons">
                                    <button type="submit" className="save-name">{t('Save')}</button>
                                    <button type="button" className="close-name" onClick={closeFn}>{t('Cancel')}</button>
                                </div>
                            </Form>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}

export default ModalChangePassword;


// WEBPACK FOOTER //
// ./src/components/modals/ModalChangePassword.js